import { createApp } from 'vue';
import App from './App.vue';
import { router } from './router';

import { Locale } from 'vant';
// 引入日语语言包
import jaJp from 'vant/es/locale/lang/ja-JP';

import vant from 'vant'
import 'vant/es/dialog/style';
import 'vant/lib/index.css';

import './assets/css/base.css';
import "./assets/css/home.css";
import "./assets/css/login.css";
import "./assets/css/mypage.css";
import "./assets/css/reset.css";
import "./assets/css/style.css";
import "./assets/css/tel.css";
import "./assets/css/video_prototype.css";
import "./assets/css/video.css";


import store from './store'

Locale.use('ja-JP', jaJp);

const app = createApp(App)
app.use(router).mount('#app')
app.use(vant)
app.use(store)

